import { Delete, PersonPin, PictureAsPdf } from "@mui/icons-material";
import { IconButton, Tooltip, Typography } from "@mui/material";

import { useContext } from "react";
import clienteAxios from "../../../../config/axios";
import AuthContext from "../../../../Context/Auth/AuthContext";
export const CalendarEvent = ({ event: { event }, showPdf }) => {
  const { usuario } = useContext(AuthContext);
  console.log(event);

  return (
    <>
      <Tooltip
        followCursor={!showPdf}
        title={
          <Typography>
            <Typography
              variant="caption"
              display={"block"}
              fontSize={".7rem"}
              fontWeight={"bold"}
            >
              {new Date(event.desde).toLocaleString("es-ES", {
                month: "2-digit",
                day: "2-digit",
                minute: "2-digit",
                hour: "2-digit",
              })}
              {" >> "}
              {new Date(event.hasta).toLocaleString("es-ES", {
                weekday: "short",
                month: "2-digit",
                day: "2-digit",
                minute: "2-digit",
                hour: "2-digit",
              })}
            </Typography>
            <IconButton
              color="error"
              onClick={() => {
                window.open(
                  `${clienteAxios.defaults.baseURL}reportes/horarios_por_persona?rucempresa=${usuario.rucempresa}&perId=${event.dht_id_persona}`
                );
              }}
            >
              <PictureAsPdf />
            </IconButton>
          </Typography>
        }
        arrow
      >
        <Typography
          variant="caption"
          display={"block"}
          fontSize={".7rem"}
          fontWeight={"bold"}
        >
          {event.nombre} {" -- "}
          {new Date(event.desde).toLocaleString("es-ES", {
            month: "2-digit",
            day: "2-digit",
            minute: "2-digit",
            hour: "2-digit",
          })}
          {" >> "}
          {new Date(event.hasta).toLocaleString("es-ES", {
            weekday: "short",
            month: "2-digit",
            day: "2-digit",
            minute: "2-digit",
            hour: "2-digit",
          })}
        </Typography>
      </Tooltip>
    </>
  );
};
